/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const routers = [{
  // 云官网管理
  path: '/map/list',
  name: 'map_list',
  component: () => import('./List.vue')
}]
export default routers